import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../../utils/axios';
import Modal from '../Modal/Modal';
import Button from '../Button/Button';
import { useAuth } from '../../context/AuthContext/AuthContext';

const PayoutSuccessModal = () => {
    const navigate = useNavigate();
    const { profile, payoutNeedsOnboarding } = useAuth();
    const primaryRole = profile?.roles?.primary;

    const previousNeedsOnboarding = useRef(payoutNeedsOnboarding);
    const [show, setShow] = useState(false);

    useEffect(() => {
        const justCompleted =
            previousNeedsOnboarding.current === true && payoutNeedsOnboarding === false;
        previousNeedsOnboarding.current = payoutNeedsOnboarding;

        if (!justCompleted || primaryRole !== 'HOST_ADMIN') return;

        let cancelled = false;
        axios.get('/listings')
            .then((response) => {
                const listings = response.data?.listings ?? [];
                if (!cancelled && listings.length === 0) {
                    setShow(true);
                }
            })
            .catch((error) => {
                // Fail closed: leave the modal hidden, but surface the failure for debugging.
                // Skip once unmounted so a late rejection doesn't log against a dead component.
                if (!cancelled) {
                    console.error('Error fetching listings:', error);
                }
            });

        return () => { cancelled = true; };
    }, [payoutNeedsOnboarding, primaryRole]);

    if (!show) return null;

    const closeModal = () => {
        setShow(false);
    };

    const goToAddProperty = () => {
        closeModal();
        navigate('/dashboard/listings/new/1');
    };

    return (
        <Modal
            show={true}
            allowCloseVeilClick={true}
            showTopCloseButton={true}
            handleClose={closeModal}
            size="medium"
        >
            <h2 className="text-2xl leading-8 font-bold text-gray-900">
                You're all set!
            </h2>
            <div className="my-8 text-base text-gray-500">
                <p>
                    Now let's get your first property submitted for approval.
                </p>
            </div>
            <div className="flex flex-col items-center gap-y-4">
                <Button onClick={goToAddProperty} variant="primary" size="normal" className="w-full">
                    Submit a property
                </Button>
                <Button onClick={closeModal} variant="text-link" size="small">
                    Maybe later
                </Button>
            </div>
        </Modal>
    );
};

export default PayoutSuccessModal;
